var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftAlignmentButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 1.5C2.66421 1.5 3 1.83579 3 2.25V21.75C3 22.1642 2.66421 22.5 2.25 22.5C1.83579 22.5 1.5 22.1642 1.5 21.75V2.25C1.5 1.83579 1.83579 1.5 2.25 1.5Z",
    fill: "#585858"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 7.125C4.5 6.50368 5.05964 6 5.75 6H18.25C18.9404 6 19.5 6.50368 19.5 7.125V9.375C19.5 9.99632 18.9404 10.5 18.25 10.5H5.75C5.05964 10.5 4.5 9.99632 4.5 9.375V7.125Z",
    fill: "#585858"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.5C5.17157 13.5 4.5 14.0037 4.5 14.625V16.875C4.5 17.4963 5.17157 18 6 18H21C21.8284 18 22.5 17.4963 22.5 16.875V14.625C22.5 14.0037 21.8284 13.5 21 13.5H6Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftAlignmentButton);
export default __webpack_public_path__ + "static/media/leftAlignmentButton.5fe3877bbd3fd79e739f92a094c7e6a9.svg";
export { ForwardRef as ReactComponent };